import { Component } from '@angular/core';

import { BasicContentVariantInheritableComponent } from '../basic-content-variant.inheritable.component';
import { ComposableCardComponent } from '../../../composables/card/card.component';
import { BasicContentPartialTopBetweenComponent } from '../../partials/basic-content-partial-top-between/basic-content-partial-top-between.component';

@Component({
  selector: 'wl-basic-content-variant-minimal',
  templateUrl: './basic-content-variant-minimal.component.html',
  styleUrls: [],
  standalone: true,
  imports: [ComposableCardComponent, BasicContentPartialTopBetweenComponent],
})
export class BasicContentVariantMinimalComponent extends BasicContentVariantInheritableComponent {}
